import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {UserService} from "../../services/user.service";
import {Router, ActivatedRoute, Params} from "@angular/router";
import {SharedService} from "../../services/shared.service";
import {Constants} from "../../services/constants";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']

})
export class LoginComponent implements OnInit {
  @Input() shouldRedirect: boolean = true;
  @Output() onLoginSucceeded: EventEmitter<boolean> = new EventEmitter();
  hasError: boolean = false;
  isRegistered: boolean = false;
  username: string;
  password: string;

  constructor(private userService: UserService,
              private route: ActivatedRoute,
              private sharedService: SharedService,
              private router: Router) {
  }

  ngOnInit() {
    if(this.userService.isLoggedIn()) {
      this.navigateUser();
    }

    this.route.queryParams
      .subscribe(data => {
        let id = data['id'];
        if(id && id.length > 10) {
          this.userService.activate(id)
            .subscribe(response => {
              this.isRegistered = true;
            })
        }
      })
  }

  onSubmit(username, password) {
    this.userService.login(username, password)
      .then((result: any) => {
          if (result.status == "error") {
            this.hasError = true;
            setTimeout(() => {
              this.hasError = false;
            }, 5000);
          }
          else if (result.access_token) {
            setTimeout(() => {
              this.navigateUser();
            }, 500)
          }
        },
        error => {
          this.hasError = true;
          setTimeout(() => {
            this.hasError = false;
          }, 5000);
        })
  }

  navigateUser() {
    if (this.userService.isSuperAdmin() || this.userService.isReseller() || this.userService.isVendor()) {
      window.location.href = "http://" + Constants.MOTHERSHIP_TENANT() + "/login";
      return;
    }
    this.onLoginSucceeded.emit(true);
    if (!this.shouldRedirect) {
      return;
    }
    let url = localStorage.getItem("redirectUrl");
    localStorage.removeItem("redirectUrl");

    if (url) {
      if (url.indexOf("/buyer") > -1 && !this.userService.isBuyer()) {
        url = null;
      }

      if (url) {
        this.router.navigateByUrl(url);
        return;
      }
    }
    if (this.userService.isBuyer()) {
      if (this.sharedService.getParameter("selectedPricingPlan")) {
        this.router.navigateByUrl("/buyer/checkout");
      } else {
        // window.location.href = window.location.origin + "/buyer/commerce"
        this.router.navigateByUrl("/buyer/commerce");
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts